import { AppState } from '../root.reducer';

export const getManualPaymentsStateByClaimId = (state: AppState, claimId: string) => {
  return state.manualPayments.byClaimId[claimId];
};
